import React, { FunctionComponent, useCallback, useEffect } from 'react';
import { useMediaQuery } from '@rbx/ui';
import useKeyboardNavigation from '@modules/layout/layout/hooks/useKeyboardNavigation';
import { KeyShortcut } from '@modules/layout/layout/utils/keyboardShortcutHandler';
import SearchDialogV2 from '@modules/ui/search/SearchDialogV2';
import useNavigationSearch from '@modules/layout/topNavigation/hooks/useNavigationSearch';
import { ESearchInteraction } from '@modules/eventStream/enum/DocsSiteSearch';

const SearchContainer: FunctionComponent<React.PropsWithChildren> = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('Medium'));
  const { searchSessionId, searchDialogOpen, toggleSearchDialogOpenWithEvent } =
    useNavigationSearch();

  const onKeyboardShortcut = useCallback(
    () => toggleSearchDialogOpenWithEvent({ interaction: ESearchInteraction.Shortcut }),
    [toggleSearchDialogOpenWithEvent],
  );
  useKeyboardNavigation(KeyShortcut.Search, onKeyboardShortcut);

  useEffect(() => {
    if (!isMobile) return undefined;
    // Control body overflow when dialog is open, only for mobile
    if (typeof document === 'undefined') return undefined;

    const { body } = document;
    const originalOverflow = body.style.overflow;

    if (searchDialogOpen) {
      body.style.overflow = 'hidden';
    } else {
      body.style.overflow = originalOverflow || '';
    }

    // Cleanup function to restore original overflow
    return () => {
      body.style.overflow = originalOverflow || '';
    };
  }, [isMobile, searchDialogOpen]);

  return <SearchDialogV2 open={searchDialogOpen} searchSessionId={searchSessionId} />;
};

export default SearchContainer;
